import { render, staticRenderFns } from "./KeyForm.vue?vue&type=template&id=bccf882c"
import script from "./KeyForm.vue?vue&type=script&lang=js"
export * from "./KeyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports